import React from "react";
import { Link } from "react-router-dom";
import { Clock, BookMarked, Star, Award, ShieldCheck } from "lucide-react";

export default function CourseCard({ course }) {
  const isPartner = Boolean(course.partner_id);
  return (
    <Link
      to={`/courses/${course.slug}`}
      data-testid={`course-card-${course.slug}`}
      className="card-lift group block bg-white border border-[#E5E7EB] rounded-2xl overflow-hidden"
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-[#F3F4F6]">
        <img
          src={course.thumbnail_url || "https://images.unsplash.com/photo-1637139496880-52af24614d79?q=80&w=1200&fm=jpg"}
          alt={course.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3 bg-white/90 backdrop-blur text-[10px] font-bold tracking-widest uppercase px-2.5 py-1 rounded-full text-[#064E3B] border border-[#064E3B]/20">
          {course.category_name}
        </div>
        <div className="absolute top-3 right-3 bg-[#111827] text-white text-[10px] font-bold tracking-widest uppercase px-2.5 py-1 rounded-full">
          {course.level}
        </div>
        {isPartner && (
          <div className="absolute bottom-3 left-3 right-3 bg-[#064E3B]/95 backdrop-blur text-white text-[10px] font-bold tracking-wide uppercase px-2.5 py-1.5 rounded-lg flex items-center gap-1.5 shadow-lg"
            data-testid={`course-card-partner-${course.slug}`}>
            <ShieldCheck className="w-3 h-3 text-[#F59E0B]" />
            <span className="truncate">Powered by {course.partner_name}</span>
          </div>
        )}
      </div>
      <div className="p-5">
        <h3 className="font-display font-bold text-lg leading-tight text-[#111827] group-hover:text-[#D92D20] transition-colors">
          {course.title}
        </h3>
        <p className="text-sm text-[#4B5563] mt-2 line-clamp-2">{course.short_description}</p>
        <div className="flex items-center gap-4 mt-4 text-xs text-[#4B5563]">
          <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" />{course.duration_hours}h</span>
          <span className="flex items-center gap-1"><BookMarked className="w-3.5 h-3.5" />{course.module_count} modules</span>
          <span className="flex items-center gap-1"><Star className="w-3.5 h-3.5 fill-[#D97706] text-[#D97706]" />{course.rating}</span>
          <span className="flex items-center gap-1"><Award className="w-3.5 h-3.5 text-[#064E3B]" />Certificate</span>
        </div>
        <div className="flex items-center justify-between mt-5 pt-4 border-t border-[#E5E7EB]">
          <div className="font-display font-black text-2xl">${course.price_usd}</div>
          <span className="text-sm font-semibold text-[#D92D20] group-hover:underline">View course →</span>
        </div>
      </div>
    </Link>
  );
}
